import * as S from "./SearchDatesSelect.styles";
import React, { useCallback, useMemo, useState, useEffect } from "react";
import moment from 'moment'
import { Button, SelectBox } from "ui";
import { getDates } from "./SearchDatesSelect.config";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export const SearchDatesSelect = ({
  setTime,
  styles,
  handleBlur,
  controlStyles,
  clearDate,
}) => {
  const [opened, setOpened] = useState(false);
  const [dateFrom, setDateFrom] = useState(moment(new Date()));
  const [dateTo, setDateTo] = useState(moment(new Date()));
  const [isDatesFilterOpen, setIsDatesFilterOpen] = useState(false);
  const [customDateValue, setCustomDateValue] = useState(null);
  
  const dropdownDates = useMemo(() => {
    const originalDates = getDates(() => setIsDatesFilterOpen(true), () => setIsDatesFilterOpen(false));
    return originalDates.map(date => ({
      ...date,
      props: {}
    }));
  }, []);
  
  const [selectedDate, setSelectedDate] = useState(dropdownDates[0]);
  
  const currentSelectedDate = useMemo(() => {
    if (customDateValue && selectedDate?.id === 5) {
      return {
        ...dropdownDates[5],
        label: customDateValue,
        value: customDateValue
      };
    }
    return selectedDate;
  }, [customDateValue, selectedDate, dropdownDates]);

  useEffect(() => {
    setSelectedDate(dropdownDates[0]);
  }, [clearDate, dropdownDates]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isDatesFilterOpen) {
        const datePickerContainer = document.querySelector('.SearchDatesSelect');
        const dateFilterContainer = document.querySelector('[customcss]');
        
        if (datePickerContainer && !datePickerContainer.contains(event.target) &&
            dateFilterContainer && !dateFilterContainer.contains(event.target)) {
          setIsDatesFilterOpen(false);
          setOpened(false);
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDatesFilterOpen]);

  const onDateFromChange = (date) => {
    setDateFrom(moment(date));
  };

  const onDateToChange = (date) => {
    setDateTo(moment(date));
  };

  const onSelectGo = useCallback(() => {
    const dateValue = `${moment(dateFrom).format('DD MMM YYYY HH:mm')} - ${moment(dateTo).format('DD MMM YYYY HH:mm')}`;
    setTime({dateFrom: moment(dateFrom).format('DD MMM YYYY HH:mm'), dateTo: moment(dateTo).format('DD MMM YYYY HH:mm')});
    setCustomDateValue(dateValue);
    setSelectedDate(dropdownDates[5]);
  }, [dateFrom, dateTo, dropdownDates]);

  const openMenu = useMemo(() => {
    if (isDatesFilterOpen) return true;
    if (!opened && !isDatesFilterOpen) return false;
    return opened;
  }, [isDatesFilterOpen, opened]);

  return (
    <>
      <SelectBox
        list={dropdownDates}
        onChange={(e) => {
          if (e.id === 5) {
            setSelectedDate(e);
            setIsDatesFilterOpen(true);
          } else {
            setTime(e.value);
            setSelectedDate(e);
            setIsDatesFilterOpen(false);
            setCustomDateValue(null);
          }
        }}
        className="SearchDatesSelect"
        menuIsOpen={openMenu}
        onMenuOpen={() => setOpened(true)}
        onMenuClose={() => {
          setOpened(false);
        }}
        controlStyles={controlStyles}
        value={currentSelectedDate}
      />
      {isDatesFilterOpen && (
        <S.DatesFilterContainer 
          customcss={styles}
          style={customDateValue && selectedDate?.id === 5 ? { marginLeft: '80px' } : {}}
        >
          <div style={{display: 'inline-block'}}>
            <div>From</div>
            <DatePicker
              selected={dateFrom}
              className="date-picker-input"
              showTimeInput
              dateFormat="yyyy-MM-dd h:mm"
              onChange={onDateFromChange}
            />
          </div>
          <div style={{display: 'inline-block'}}>
            <div>To</div>
            <DatePicker
              selected={dateTo}
              className="date-picker-input"
              showTimeInput
              dateFormat="yyyy-MM-dd h:mm"
              onChange={onDateToChange}
            />
          </div>
          <Button
            onClick={() => {
              onSelectGo();
              setOpened(false);
              setIsDatesFilterOpen(false);
              handleBlur(false);
            }}
            style={{ marginBottom: '-4px' }}
          >
            Go
          </Button>
        </S.DatesFilterContainer>
      )}
    </>
  );
};
